
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[cardId]",
      function () {
        return require("private-next-pages/[cardId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[cardId]"])
      });
    }
  